module.exports = __webpack_public_path__ + "img/blog-cover-call-privacy-gbmodshub.af018a92.jpg";